<template>
  <div class="super">
    <ul class="menu-bar">
      <li class="menu-icon">
        <AdjustmentsIcon @click="toggleAdmin" />
      </li>
    </ul>
    <div v-if="showMakeAdmin">
      <SignupForm />
    </div>
    <div v-else>
      <MakeAdmin @adminEmail="toast = true" />
    </div>
  </div>
</template>

<script>
import SignupForm from '@/components/SignupForm.vue'
import MakeAdmin from '@/components/MakeAdmin.vue'
import { AdjustmentsIcon } from '@heroicons/vue/outline'
import { ref } from '@vue/reactivity'

export default {
  components: { SignupForm, MakeAdmin, AdjustmentsIcon },
  setup () {
    const showMakeAdmin = ref(false)
    const toast = ref(false)

    const toggleAdmin = () => {
      showMakeAdmin.value = !showMakeAdmin.value
    }

    return { toggleAdmin, showMakeAdmin, toast }
  }
}
</script>

<style>
.super {
  margin-top: 2em;
}
.super .menu-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  font-weight: 400;
  user-select: none;

  margin: 0.1em 0;
  padding: 0.4em;
  border-radius: 0.25em;
  height: 1.5em;

  color: white;
  list-style-type: none;
}
.super .menu-bar .menu-icon {
  width: 25px;
}
</style>
